import { render, staticRenderFns } from "./EmploymentStatus.vue?vue&type=template&id=5a863916&scoped=true"
import script from "./EmploymentStatus.vue?vue&type=script&lang=js"
export * from "./EmploymentStatus.vue?vue&type=script&lang=js"
import style0 from "./EmploymentStatus.vue?vue&type=style&index=0&id=5a863916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a863916",
  null
  
)

export default component.exports